import { MicIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { Button } from '../../../components/ui/button.tsx';
import { useLocale } from '../../../lib/hooks/use-locale.ts';
import type { VoiceInputPayload } from '../../analytics/types/analytics-events.ts';
import { DialogStateManager } from '../../dialog/dialog-provider.tsx';
import { RecordingDialog } from './recording-dialog.tsx';

type Props = {
    trackingContext: VoiceInputPayload;
    disabled?: boolean;
    onTranscription: (text: string) => void;
};

export function VoiceRecordingButton({
    trackingContext,
    disabled = false,
    onTranscription,
}: Props): ReactNode {
    const { t } = useLocale();

    return (
        <Button
            type="button"
            variant="secondary"
            size="sm"
            icon={MicIcon}
            disabled={disabled}
            aria-label={t('voice__start_recording', { ns: 'common' })}
            onClick={() => {
                void DialogStateManager.show(RecordingDialog, {
                    trackingContext,
                    onTranscribed: onTranscription,
                });
            }}
        />
    );
}
